webpackJsonp([35],{

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(567)(
  /* script */
  null,
  /* template */
  __webpack_require__(1891),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1891:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("ERROR 404")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/35.8e0efebfe840b2cd4485.js